import { useMemo } from 'react';
import { useStore } from '@/store';
import { L, translations, type Lang, type Translations } from './strings';

/** Translated chrome strings for the active language. */
export function useT(): Translations {
  const language = useStore((s) => s.language);
  return useMemo(() => translations(language), [language]);
}

/** The active language, for interpolated strings and speech locale. */
export function useLang(): Lang {
  return useStore((s) => s.language);
}

/** Interpolated strings that don't live in the flat map. */
export function useL(): (o: { AU: string; 中文?: string; Fil?: string }) => string {
  const lang = useLang();
  return useMemo(() => (o: { AU: string; 中文?: string; Fil?: string }) => L(lang, o), [lang]);
}
